export type ManagerSegmentVisibilityServer = {
  show_segment: boolean;
};

export type ManagerSegmentAnswerServer = {
  question: ManagerSegmentQuestion;
  values: ManagerSegmentAnswerValue[];
};

export type ManagerSegmentCompleteServer = {
  segment: ManagerSegment;
  answers: ManagerSegmentAnswerServer[];
  segment_other_text: string | null;
  task_other_text: string | null;
};

export enum ManagerSegment {
  marketer = 'marketer',
  customerSupport = 'customer_support',
  socialCommunity = 'social_community',
  clientAutomation = 'client_automation',
  internalAutomation = 'internal_automation',
  other = 'other'
}

export enum ManagerSegmentQuestion {
  marketerTasks = 'marketer_tasks',
  supportTeam = 'support_team',
  supportProcess = 'support_process',
  supportContactChannels = 'support_contact_channels',
  socialTasks = 'social_tasks',
  clientChannels = 'client_channels',
  clientIntegrations = 'client_integrations',
  clientScenarios = 'client_scenarios',
  clientWorkFormat = 'client_work_format',
  internalDepartments = 'internal_departments',
  internalAutomations = 'internal_automations',
  generalTasks = 'general_tasks'
}

export enum ManagerSegmentAnswerValue {
  leadGenerationFunnels = 'lead_generation_funnels',
  campaigns = 'campaigns',
  recurringCampaigns = 'recurring_campaigns',
  audienceSegmentation = 'audience_segmentation',
  userDataCollection = 'user_data_collection',
  externalIntegrations = 'external_integrations',
  solo = 'solo',
  smallTeamUpToFive = 'small_team_up_to_5',
  largerTeam = 'larger_team',
  routing = 'routing',
  responseSla = 'response_sla',
  botsAndAiSupport = 'bots_and_ai_support',
  answerInSmartbot = 'answer_in_smartbot',
  answerInCrm = 'answer_in_crm',
  answerInExternalHelpdesk = 'answer_in_external_helpdesk',
  messengersAndSocial = 'messengers_and_social',
  websiteWidget = 'website_widget',
  email = 'email',
  socialFaq = 'social_faq',
  communityActivities = 'community_activities',
  routeComplexRequests = 'route_complex_requests',
  vk = 'vk',
  telegram = 'telegram',
  max = 'max',
  whatsapp = 'whatsapp',
  jivo = 'jivo',
  viber = 'viber',
  avito = 'avito',
  odnoklassniki = 'odnoklassniki',
  crmIntegrations = 'crm_integrations',
  paymentIntegrations = 'payment_integrations',
  deliveryIntegrations = 'delivery_integrations',
  telephonyIntegrations = 'telephony_integrations',
  dataSourceIntegrations = 'data_source_integrations',
  clientInternalSystemIntegrations = 'client_internal_system_integrations',
  dialogScenarios = 'dialog_scenarios',
  branchingScenarios = 'branching_scenarios',
  aiScenarios = 'ai_scenarios',
  delayedActions = 'delayed_actions',
  multipleClientProjects = 'multiple_client_projects',
  workInClientCabinet = 'work_in_client_cabinet',
  automateHr = 'automate_hr',
  automateSales = 'automate_sales',
  automateMarketing = 'automate_marketing',
  automateSupport = 'automate_support',
  automateBackOffice = 'automate_back_office',
  automateFinance = 'automate_finance',
  automateIt = 'automate_it',
  employeeNotifications = 'employee_notifications',
  employeeOnboarding = 'employee_onboarding',
  internalSystemIntegrations = 'internal_system_integrations',
  answerCustomerRequests = 'answer_customer_requests',
  socialCommunityManagement = 'social_community_management',
  other = 'other'
}
